export function pathNormalize(url: string) {
  let normalizedUrl = url.replace(/(https?:\/\/)|(\/)+/g, (match: string, protocol: string) => {
    if (protocol) {
      return protocol;
    } else {
      return '/';
    }
  });

  const urlAsClass = new URL(normalizedUrl);
  if (urlAsClass.pathname.endsWith('/')) {
    urlAsClass.pathname = urlAsClass.pathname.slice(0, -1);
  }
  normalizedUrl = urlAsClass.toString();

  return normalizedUrl;
}

export function getAbsoluteUrlWithAllParams(urlOrPath: string) {
  let url = window.location.origin;
  if (urlOrPath.startsWith('http')) {
    url = urlOrPath;
  } else {
    url += urlOrPath;
  }

  url = pathNormalize(url);

  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.search);

  const newUrl = new URL(url);
  const newUrlParams = new URLSearchParams(newUrl.search);
  for (const [key, value] of params) {
    newUrlParams.append(key, value);
  }
  newUrl.search = newUrlParams.toString();
  return newUrl.toString();
}

export function getLocalePath(path: string) {
  const locale = window.location.pathname.split('/')[1] ?? 'en';
  return `/${locale}${path}`;
}

export function getPageName() {
  return window.location.pathname.split('/').filter(Boolean).pop() ?? '';
}
